<template>
	<div class="x_box">
		<ol class="breadcrumb x_breadcrumb">
			<li class="breadcrumb-item"><router-link to="/customer">{{ $t("customer_list") }}</router-link></li>
			<li class="breadcrumb-item active" aria-current="page">{{ $t("new") }}</li>
		</ol>
		<div class="x_header">
			<button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)">
				<i class="fa fa-arrow-circle-o-left"></i> {{ $t("back") }}
			</button>
			<button
					type="button"
					class="btn btn-outline-primary btn-sm no-bor"
					@click="clickSaveHandler">
				<i class="fa fa-floppy-o"></i> {{ $t("save") }}
			</button>
		</div>
		<div class="x_body">
			<div class="card f_card no-bor">
				<div class="card-header">
					<div class="card-item">{{ $t("create_new_customer") }}</div>
				</div>
				<div class="card-body">
					<div v-if="$v.$error" class="alert alert-danger x-error">
						<div class="error" v-if="!$v.model.Name.required">- សូមធ្វើកាបញ្ចូលឈ្មោះ</div>
						<div class="error" v-if="!$v.model.Phone.required">- សូមធ្វើកាបញ្ចូលលេខទូរស័ព្ទ</div>
					</div>
					<div class="row">
						<div class="col-sm-5">
							<div class="row">
								<div class="col-sm-6 form-group">
									<label class="label-control blue">VAT TIN</label>
									<div>
										<div class="d-flex" style="gap: 5px;">	
											<div>
												<input type="text" class="form-control" v-model="model.TinHead"/>
											</div>
											<div>
												<b-form-input v-model="model.VatTin"/>
											</div>
										</div>
									</div>
								</div>
								<div class="col-sm-6">
									<div class="form-group">
										<label class="label-control blue">{{ $t("customer_type") }}</label>
										<div>
											<select class="form-control" type="text" v-model="model.CustomerTypeId">
												<option value="">Not Set</option>
												<option v-for="ret in types" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
											</select>
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-6">
									<div class="form-group" :class="{ 'form-group-error': $v.model.Name.$error }">
										<label class="label-control blue">{{ $t('khmer_name')}}</label>
										<div><input class="form-control" type="text" v-model="$v.model.Name.$model" /></div>
									</div>
								</div>
								<div class="col-sm-6">
									<div class="form-group">
										<label class="label-control blue">{{ $t('latin_name')}}</label>
										<div><input class="form-control" type="text" v-model="model.NameEng" /></div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-4">
									<div class="form-group" :class="{ 'form-group-error': $v.model.Phone.$error }">
										<label class="label-control blue"> {{ $t("phone") }}</label>
										<div>
											<input class="form-control" type="text" v-model="model.Phone" />
										</div>
									</div>
								</div>
								<div class="col-sm-4">
									<div class="form-group">
										<label class="label-control blue">{{ $t("email") }}</label>
										<div>
											<input class="form-control" type="email" v-model="model.Email" />
										</div>
									</div>
								</div>
								<div class="col-sm-4">
									<div class="form-group">
										<label class="label-control blue">{{ $t("website") }}</label>
										<div>
											<input class="form-control" type="text" v-model="model.Website" />
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-4">
									<div class="form-group">
										<label class="label-control blue">{{ $t("sale_reputation") }}</label>
										<div>
											<select class="form-control" type="text" v-model="model.EmployeeId">
												<option value="">Not Set</option>
												<option v-for="ret in employees" :value="ret.Id" :key="ret.Id">{{ret.KhmerName}}</option>
											</select>
										</div>
									</div>
								</div>
								<div class="col-sm-8">
									<div class="form-group">
										<label class="label-control blue">{{ $t("address") }}</label>
										<div>
											<input class="form-control" type="text" v-model="model.Address" />
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-sm-6">
							<div>
								<input type="file" ref="file" @change="fileChangeHandler" accept="image/*" style="display:none;"/>
								<img :src="img" alt="" class="img-thumbnail" style="width: 135px; height: 125px;" @click="$refs.file.click()">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { required } from 'vuelidate/lib/validators'
	import Swal from "sweetalert2";
	export default {
		data: function () {
			return {
				model: {
					Name: "",
					Phone: "",
					VatTin: "",
					TinHead: ""
				},
				actionLink: "customer/save",
				types: [],
				img: '/img/no-image.svg',
				formHead: {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				},
				employees: []
			}
		},
		validations:{
			model: {
				Name: { required },
				Phone: { required },
			}
		},
		created: function () {
			let id = this.$route.params.id;
			this.listCustomerType();
			this.listEmployee();
			if (id !== undefined && id != null && id !== "") {
				this.actionLink = "customer/update";
				this.$api()
						.post("customer/find", { Id: id })
						.then((res) => {
							if (this.$isValid(res)) {
								this.model = res.data.Data;
								if(this.model.Image != null){
									this.img = this.$base() + 'image/image/' + this.model.Image;
								}
							}
						});
			}
		},
		methods: {
			clickSaveHandler: function () {
				this.$v.$touch();
				if(!this.$v.$invalid) {
					let loading = this.$loading.show();
					let formData = new FormData();
					formData.append('File', this.$refs.file.files[0]);
					for (let p in this.model) {
						let val = this.model[p];
						if(val != null)
							formData.append(p, val);
					}
					this.$api().post(this.actionLink, formData, this.formHead).then((res) => {
						if (this.$isValid(res)) {
							Swal.fire('Success', 'The customer save success.', 'success');
							this.$router.push("/customer");
						}
					}).finally(function () {
						loading.hide();
					});
				}
			},
			listCustomerType(){
				this.$api().post('customer/types').then(res => {
					this.types = res.data.Json.Types;
				});
			},
			listEmployee(){
				this.$api().post('employees', { Limit: 0 }).then(res => {
					this.employees = res.data.Data;
				});
			},
			fileChangeHandler: function(e){
				const file = e.target.files[0];
				this.img = URL.createObjectURL(file);
			}
		}
	};
</script>
